import { twMerge } from 'tailwind-merge';

type THTMLHeading = React.HTMLAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLSpanElement>;

export type THeading = THTMLHeading & {
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
  className?: string;
  children: string;
  highlight?: string;
  underline?: boolean;
};

export const Heading = ({
  variant: Cmp = 'span',
  className = '',
  children,
  highlight = '',
  underline = false,
  ...rest
}: THeading) => {
  if (!highlight) {
    return (
      <Cmp {...rest} className={twMerge('font-oswald text-4xl uppercase', Cmp === 'span' && 'block', className)}>
        {children}
        {underline && (
          <div className="flex items-center gap-2 mt-2 w-3/4">
            <div className="h-1 basis-1/3 rounded-full bg-action" />
            <div className="h-[2px] basis-2/3 rounded-full bg-neutral-700/70" />
          </div>
        )}
      </Cmp>
    );
  }

  const parts = children.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <Cmp {...rest} className={twMerge('font-oswald text-4xl uppercase', Cmp === 'span' && 'block', className)}>
      {parts.map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <span key={index} className="text-action">
            {part}
          </span>
        ) : (
          part
        )
      )}
      {underline && (
        <div className="flex items-center gap-2">
          <div className="h-1 w-6 rounded-full bg-action" />
          <div className="h-[2px] w-16 rounded-full bg-neutral-700/70" />
        </div>
      )}
    </Cmp>
  );
};
